const o = {
  ChevronDownSolidIcon: () => import("@toruslabs/vue-icons/arrows/ChevronDownSolidIcon"),
  ChevronRightIcon: () => import("@toruslabs/vue-icons/arrows/ChevronRightIcon"),
  ChevronLeftIcon: () => import("@toruslabs/vue-icons/arrows/ChevronLeftIcon"),
  ChevronUpSolidIcon: () => import("@toruslabs/vue-icons/arrows/ChevronUpSolidIcon"),
  XCircleSolidIcon: () => import("@toruslabs/vue-icons/notifications/XCircleSolidIcon"),
  ExternalLinkIcon: () => import("@toruslabs/vue-icons/mail/ExternalLinkIcon"),
  ScannerIcon: () => import("./scanner-DeXuJ71C.js"),
  XSolidIcon: () => import("@toruslabs/vue-icons/notifications/XSolidIcon"),
  ExternalLinkSolidIcon: () => import("@toruslabs/vue-icons/mail/ExternalLinkSolidIcon"),
  LinkSolidIcon: () => import("@toruslabs/vue-icons/mail/LinkSolidIcon"),
  ExclamationCircleSolidIcon: () => import("@toruslabs/vue-icons/notifications/ExclamationCircleSolidIcon")
};
export {
  o as default
};
